import React, { useState } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import * as Yup from "yup";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { requestPassword } from "../_redux/authCrud";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import {toastMe } from "../../../../_components/Axios";

const initialValues = {
  userName: "",
};

function ForgotPassword(props) {
  const { intl } = props;
  const [isRequested, setIsRequested] = useState(false);
  const ForgotPasswordSchema = Yup.object().shape({
    userName: Yup.string().trim()
      .min(3, "Minimum 3 characters")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      requestPassword(values.userName)
        .then((response) => {
        if (response.error) toastMe(true, response.message, "warning");
        else toastMe(true, response.data.statusCode.message, "success");
        setIsRequested(true)
    })
        .catch(() => {
          setIsRequested(false);
          setSubmitting(false);
          setStatus(
            intl.formatMessage(
              { id: "AUTH.VALIDATION.NOT_FOUND" },
              { name: values.userName }
            )
          );
        });
    },
  });

  return (
    <>
    {isRequested && <Redirect to="/auth/email-sent" />}
      {!isRequested && (
        <div className="login-form login-forgot" style={{ display: "block" }}>
        {/* begin::Head */}
        <div className="text-center mb-10 mb-lg-20">
          
        <Link to="/" className="flex-column-auto mt-5 pb-lg-0 pb-10">
                  <img
                    alt="Logo"
                    className="max-h-70px"
                    src={toAbsoluteUrl("/media/logos/logo-dark.png")}
                  />
                </Link>
        </div>
        {/* end::Head */}
              <Link to="/auth">
                <button
                  type="button"
                  id="kt_login_forgot_cancel"
                  className="btn btn-white font-weight-bold px-9 py-4 my-3 "
                >
                🡐  Back
                </button>
              </Link>
          <form
            onSubmit={formik.handleSubmit}
            className="form auth fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          >
          <div className="text-left mb-10 mb-lg-20">
            <h3 className="font-size-h3 text-white">Forget Password?</h3>
            <div className="text-muted font-weight-bold">
            Please enter your register user name. We will send instructions to help reset your password
            </div>
          </div>
            {formik.status && (
              <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            )}
            <div className="form-group fv-plugins-icon-container">
              <input
                type="text"
                placeholder="Enter Your User Name"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "userName"
                )}`}
                name="userName"
                {...formik.getFieldProps("userName")}
              />
              {formik.touched.email && formik.errors.userName ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.userName}</div>
                </div>
              ) : null}
            </div>
            <div className="form-group d-flex flex-wrap flex-center">
              <button
                id="kt_login_forgot_submit"
                type="submit"
                className="btn btn-light font-weight-bold px-9 py-4 my-3 mx-4"
                disabled={formik.isSubmitting}
              >
  {formik.isSubmitting?  <><span class="spinner-border spinner-border-sm pr-1" role="status" aria-hidden="true"></span>Submiting...</>:"Submit"}
                
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(ForgotPassword));
